import type { OnboardingFormSchema } from './OnboardingForm.types'

export const onboardingFormDefaultValues: OnboardingFormSchema = {
  date: null,
  ethnicity: '',
  gender: '',
  partner: '',
}
